import React from 'react'

const AD_CONFIGS = {
  concierge: {
    className: 'concierge-ad',
    iconClass: 'fa-light fa-hand-wave',
    link: '/concierge',
    title: 'concierge',
    text: 'White-glove service.',
  },
}

const AdComponent = ({ className, iconClass, link, title, text }) => {
  return (
    <div className={`${className} dome-d-flex dome-align-center dome-gap9 dome-light-shadow`}>
      <div className="ad-icon-wrapper display-only-desktop">
        <i className={`ad-icon ${iconClass} dome-color-green-gradient`}></i>
      </div>
      <div className="dome-d-flex dome-flex-column dome-align-start">
        <div className="dome-d-flex dome-justify-between">
          <a
            href={link}
            target="_blank"
            className="dome-text-w500 dome-link dome-link-aqua dome-link-chevron-right dome-color-green-gradient"
          >
            {title}
          </a>
        </div>
        <span className="dome-text-w300 dome-p3">{text}</span>
      </div>
    </div>
  )
}

export default function AdvertisementButton({ packageType }) {
  const adProps = AD_CONFIGS.concierge

  return (
    <div className="advertisement-button-wrapper dome-d-flex dome-align-center dome-flex-wrap dome-gap12">
      <AdComponent {...adProps} />
    </div>
  )
}
